import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

class FHEListingHeader extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        svgimage: PropTypes.object.isRequired,
        title: PropTypes.string.isRequired
    };

    static defaultProps = {};

    render() {
        const { classes, title, svgimage } = this.props;
        return (
            <span className={classes.dividerContent}>
                <div className={classes.img}>{svgimage}</div>
                <div className={classes.title}>{title}</div>
            </span>
        );
    }
}

const styles = theme => ({
    dividerContent: {
        backgroundColor: theme.palette.primary.main,
        display: 'inline-block',
        width: '100%',
        height: 40,
        position: 'relative',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8
    },
    img: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        position: 'absolute',
        height: 40,
        width: 40
    },
    title: {
        color: theme.palette.common.white,
        position: 'absolute',
        marginBottom: 0,
        marginTop: 0,
        paddingLeft: 40,
        lineHeight: '40px',
        maxWidth: '100%',
        maxHeight: 40,
        height: 40
    }
});

export default withStyles(styles, { withTheme: true })(FHEListingHeader);



// WEBPACK FOOTER //
// ./data/components/FHEListingHeader.js